import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../components/global/Button';
import PinField from '../../../../../../../components/global/PinField';
import WaldoSpeechBubble from '../../../../../../../components/global/WaldoSpeechBubble';
import { maskEmail } from '../../../../../../../util/email';
import { getObfuscatedPhoneNumber } from '../../../../../../../util/account';

const propTypes = {
  authMethodIsPhone: PropTypes.bool,
  emailAddress: PropTypes.string,
  phoneNumber: PropTypes.string,
  loading: PropTypes.bool,
  onVerify: PropTypes.func.isRequired,
  onPinResend: PropTypes.func.isRequired,
  onBack: PropTypes.func,
};

const PinVerifyStep = ({
  authMethodIsPhone,
  emailAddress,
  phoneNumber,
  loading,
  onVerify,
  onPinResend,
  onBack,
}) => {
  const [code, setCode] = useState('');
  const isValid = code.length === 4;

  const maskedDestination = authMethodIsPhone
    ? getObfuscatedPhoneNumber(phoneNumber)
    : maskEmail(emailAddress);

  const handleSubmit = event => {
    event.preventDefault();
    onVerify(code);
  };

  return (
    <Fragment>
      {onBack ? (
        <Button
          btnStyle="reset"
          type="button"
          className="text-primary mb-3"
          onClick={onBack}
        >
          &larr; Choose another method
        </Button>
      ) : null}
      <WaldoSpeechBubble className="w-100-i mx-0 mb-2 text-sm" position="right">
        To ensure the security of your photos, please enter the pin code{' '}
        {authMethodIsPhone ? 'texted' : 'emailed'} to{' '}
        <span className="text-primary">{maskedDestination}</span> to view them.
      </WaldoSpeechBubble>
      <div className="marketing-account-onboarding-pin-step">
        <h2 className="text-center mb-4">
          {authMethodIsPhone ? 'Verify your phone' : 'Verify your email'}
        </h2>

        <form onSubmit={handleSubmit} className="text-center">
          <div className="mb-4">
            <PinField
              autofocus
              onComplete={value => setCode(value)}
              onChange={value => setCode(value)}
            />
          </div>

          <Button
            type="submit"
            disabled={loading || !isValid}
            loading={loading}
            className="btn-primary w-100 mb-3"
            btnSize="lg"
          >
            Verify and see my matches
          </Button>

          <p className="text-muted small mb-2">
            By continuing you agree to <a href="/terms">Terms of Use</a> &{' '}
            <a href="/privacy">Privacy Policy</a>
          </p>

          <p>
            Didn&apos;t get it?{' '}
            <Button
              type="button"
              btnStyle="link"
              disabled={loading}
              className="p-0 align-baseline"
              onClick={onPinResend}
            >
              Resend PIN
            </Button>
          </p>
        </form>
      </div>
    </Fragment>
  );
};

PinVerifyStep.propTypes = propTypes;

export default PinVerifyStep;
